import type { Partner } from 'bundles/admin-v2/constants/types';

export type PartnerAdmin = Omit<Partner, 'partnerId'> & {
  partnerId: string;
};

/**
 * Adjusts the partner we receive from the backend to respect app type expectations
 *
 * The backend returns a string representation of partnerId which conflicts with the protobuf definition at
 * @coursera/grpc-types-educatoradmin/coursera/proto/educatoradmin/adminproductdirectory/v1beta1/partner
 *
 * This method should be refactored out once components in the app no longer expect a numerical partnerID.
 * */
export const makePartnerIdNumeric = (partner: PartnerAdmin): Partner => {
  return {
    ...partner,
    partnerId: Number(partner.partnerId),
  };
};
